import etlApi from 'resources/etlApi';

export function getTrackerImport(importFileId: number) {
  return etlApi.get(`/etl/v2/tracker/import/${importFileId}`);
}
